<greco-simple-dialog [data]="dialogData">
  <form [formGroup]="form">
    <mat-form-field>
      <mat-label>Label</mat-label>
      <input matInput required formControlName="label" />
    </mat-form-field>
  </form>
</greco-simple-dialog>
